export var PromotionConflictCodeEnum;
(function (PromotionConflictCodeEnum) {
    PromotionConflictCodeEnum["POS_GUID_CONFLICT"] = "POS_GUID_CONFLICT";
    PromotionConflictCodeEnum["PROMO_CODE_CONFLICT"] = "PROMO_CODE_CONFLICT";
    PromotionConflictCodeEnum["QUANTITY_RULES_CONFLICT"] = "QUANTITY_RULES_CONFLICT";
})(PromotionConflictCodeEnum || (PromotionConflictCodeEnum = {}));
//# sourceMappingURL=PromotionConflictCodeEnum.js.map